const axios = require('axios');

export default class UserService {

    sendContactUs(form) {
        
        var data = JSON.stringify(form);
          
        var config = {
            method: 'post',
            url: process.env.VUE_APP_API + '/user/contact',
            headers: { 
                'Content-Type': 'application/json'
            },
            data : data
        };
          
        return axios(config)
    }
}